export const SENTRY_TAG_IS_LOGGED_IN = 'is_logged_in';
export const SENTRY_TAG_IS_NATIVE_APP = 'is_native_app';
